export default __webpack_public_path__ + "static/media/slide_ico_on.a6f40306.svg";